import Repository from '../Repository';

export default {

	downloadRubric(rubricId) {
		var response = Repository.get('Rubric/DownloadRubric', {
			responseType: 'arraybuffer',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/pdf'
			},			
			params: {
				rubricId: rubricId
			}			
		});
		return response;
	},

	getRubrics(qualificationId, subjectId) {
		var response = Repository.get('Rubric/GetRubrics', {
			params: {
				qualificationId: qualificationId,
				subjectId: subjectId
			}			
		});
		return response;
	},

	searchRubrics(searchString) {
		var response = Repository.get('Rubric/GetRubrics', {
			params: {
				searchString: searchString
			}			
		});
		return response;
	},

	uploadRubric(files) {
		const formData = new FormData();

		var i = 0;
		while (i < files.length) {
			formData.append('files', files[i]);
			i++;
		}

		var response = Repository.post('Rubric/UploadRubric', formData, 
			{"headers": {
				"Content-Type": 'multipart/form-data'
			}}
		);

		return response;		
	}	

}
